import { z } from 'zod';

/* ===========================================================================
 * THE SETTINGS PIN, as a contract — its own file, beside
 * `field.appLock.schema.ts`, which is the device half of the same lock.
 *
 * It left `settings.schema.ts` when that file reached its ceiling: the lock is
 * a coherent thing with declarations of its own, and it was sitting in the
 * middle of a file about everything else the company can configure.
 * ======================================================================== */

// App lock — ONE settings PIN (2026-09-17), and it guards the TABLETS only
// (2026-10-22: the console's own keypad is gone; permissions decide who reaches
// console Settings). `openPinHash` is the retired tablet open PIN. Only bcrypt
// hashes are stored, never returned; NOT a SettingsCategory, so no raw hash can
// be injected via PATCH /settings/:category.
export const AppLockSettingsSchema = z.object({
  openPinHash: z.string().nullable().default(null),
  adminPinHash: z.string().nullable().default(null),
  // Digits the settings PIN was SET with: the pad uses it, so a later
  // security.pinLength change cannot make the stored PIN unmatchable.
  adminPinLength: z.number().int().min(4).max(8).nullable().default(null),
});
export type AppLockSettings = z.infer<typeof AppLockSettingsSchema>;

/** Public, hash-free view of the lock a client may read. */
export interface AppLockStatus {
  hasAdminPin: boolean;
}

/** Admin payload: set (or replace) the tablets' Settings PIN. Omitted PINs
 *  are left unchanged. Who may send it is the route's permission check, and
 *  nothing else. */
export const AppLockConfigInputSchema = z.object({
  openPin: z.string().regex(/^\d{4,8}$/, 'PIN must be 4–8 digits').optional(),
  adminPin: z.string().regex(/^\d{4,8}$/, 'PIN must be 4–8 digits').optional(),
});
export type AppLockConfigInput = z.infer<typeof AppLockConfigInputSchema>;
